import React from 'react';
import { Container } from 'reactstrap';
import Layout from 'Layout/Layout';
import PropTypes from 'prop-types';
import { withLocale } from '@dietlabs/components';

class DietSettings extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        children: PropTypes.func.isRequired,
    };

    render() {
        const { t, children } = this.props;

        return (
            <Layout page="diet">
                <Container>
                    <header>
                        <h1 className="text-center">
                            {t('make-decision/title')}
                        </h1>
                    </header>
                    <section className="pt-0">{children()}</section>
                </Container>
            </Layout>
        );
    }
}

export default withLocale(DietSettings);
